module.exports = "https://99designs-start-assets.imgix.net/js/43d1223e9f0746abf15c5c70e7fc14aa.png";